import React, {useEffect, useState, useContext} from 'react';
import styles from './integrations_hero.module.less';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Input} from '../../../../hola/pub/lib/input';
import {Button} from '../../../../hola/pub/lib/button';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

export interface i_integrations_heading_props {
    title?: string;
    title_tag?: string;
}

interface i_integrations_heading_editor_props {
    value: i_integrations_heading_props;
    on_change: (v: i_integrations_heading_props) => void;
    on_cancel: () => void;
}

export const Integrations_heading_editor = (
    props: i_integrations_heading_editor_props
)=>{
    const [state, set_state] = useState<i_integrations_heading_props>(
        props.value || {}
    );
    useEffect(()=>{
      set_state(props.value);
    }, [props.value]);
    return <div>
      <Input
        size="sm"
        label="Title"
        value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}
      />
      <Title_header_select
        value={state.title_tag}
        on_select={v=>set_state({...state, title_tag: v})}
      />
      <Button caption="Save" size="s" on_click={()=>
        props.on_change(state)} />
      <Button caption="Cancel" size="s" on_click={props.on_cancel} />
    </div>;
};

export const Integrations_heading = (props: i_integrations_heading_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(theme.container, styles.hero_container)}>
      <div className={styles.hero_text_wrapper}>
        <Dynamic_heading
          tag={props.title_tag}
          className={styles.hero_title}
          dangerouslySetInnerHTML={{
            __html:
              props.title ||
              'Seamlessly integrate with Toolip to power up your proxies',
          }}
        />
      </div>
    </div>;
};
